import styled from 'styled-components';
import { BOX_SHADOW, DARKER, PRIMARY, SECONDARY } from '../../const/colors';
import { Link } from 'react-router-dom';

export const Span = styled.span`
	position: relative;
	z-index: 2;
	&.slick-prev:before, &.slick-next:before {
		font-size: 0;
		content: '';
		height: 0;
		width: 0;
	}
    &.slick-next {
        left: 95%;
        top: -4%;
    }
    &.slick-prev {
        left: 90%;
        top: -4%;
    }
	@media screen and (max-width: 768px) {
		&.slick-next {
			left: 54%;
    		top: 100%;
		}
		&.slick-prev {
			left: inherit;
			right: 63%;
			top: 100%;
		}
	}
`;
export const WitgetContainer = styled.div`
	padding: 50px 0 0 0;
	& span.title{
		position:relative;
		font-size: 2.2rem;
		color: rgb(255, 255, 255);
		margin: 1rem 0px;
		font-weight: 800;
	}
	& span.title::after {
		content: "";
		height: 2px;
		background: ${PRIMARY};
		position: absolute;
		left: 0;
		right: 0;
		bottom: -6px;
		opacity: 0;
		transform-origin: left center;
		transition: all 0.25s cubic-bezier(0.25, 0.43, 0.45, 0.94) 0s;
		transform: scaleX(0);
	  }
	  &:hover {
		span.title:after {
		  transform: scaleX(1);
		  opacity: 1;
		}
	  }
	  & .slick-slide{
		padding: 0.4rem
	  }
	  @media screen and (max-width: 768px) {
		&.pt-init{
			padding: 30px 0 0 0;
		}
		padding: 60px 0 0 0;
		& span.title{
			font-size: 1.5rem;
			margin-bottom: 1.5rem;
			display: block;
			width:55%
		}
		& .slick-list{
			padding: 0!important;
			overflow: unset;
			transform: translate(-10px, 0px) !important;
		}
		& .slick-slide{
			padding: 0.2rem
		  }
	  }
	  
`;
export const ContainerMultiItems = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: calc(-1 * 0);
    margin-right: calc(-.5 * 1.5rem);
    margin-left: calc(-.5 * 1.5rem);

	@media screen and (max-width: 768px) {
		margin-right: 0;
		margin-left: 0;
	}
`;
export const MultiItemscolumn = styled.div`
	flex: 0 0 auto;
	width: 16.666%;
	margin-top: 1.5rem;
    margin-bottom: 1rem;
	background: white;
    border: 3px solid #ffce05;
    padding: 0;
    border-radius: 5px;
	box-shadow: 1px 1px 6px #353e7a;
	& .titlecard{
		color: black;
		text-align:center;
		text-transform: uppercase;
		font-size: 16px;
		margin: 0.5rem 0;
		font-weight: 600;
		display: block;
		padding: 0 0.5rem;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	& .titlelogo{
		background:${DARKER};
		text-align:center;
		color: white;
		text-transform: uppercase;
		font-size: 16px;
		margin-top: 0.5rem;
		font-weight: 600;
		display: block;
		padding: 0.7rem 0;
	}
	& .contentimg{
		background:${DARKER};
		width:100%;
		& img{
			margin: 0 auto;
			width: 100%;
			max-width: 120px;
			height:auto;
		}
	}
	
	&:hover{
		transform: scale(1.05);
		transition: transform 0.3s ease 0s;
	}
	@media screen and (max-width: 768px) {
		width: 50%;
		padding-right: 0rem;
		padding-left: 0rem;
		margin-top: 0.4rem;
		& .titlecard{
			font-size: 12px;
		}
	}
`;
export const MultiItemsCard = styled.div`
	padding: 0;
	height:100%;
	&.deportes{
		height:350px;
		max-height: 42vh;
	}
	& img{
	  width: 100%;
	  height:200px;
	}
	width: 100%;
	border-radius: 5px 5px 0 0;
    cursor: pointer;
	position:relative;
	background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
	transition: transform 0.3s ease 0s;
	&:hover > .new{
		box-shadow: 0 0 0 2px ${SECONDARY}, 0 0 0 4px red;
		transition-timing-function: cubic-bezier(0.6, 4, 0.3, 0.8);
		-webkit-animation: gelatine 0.5s 1;
		animation: gelatine 0.5s 1;
	}
	@keyframes gelatine {
		from, to {
		  transform: scale(1, 1);
		}
		25% {
		  transform: scale(0.9, 1.1);
		}
		50% {
		  transform: scale(1.1, 0.9);
		}
		75% {
		  transform: scale(0.95, 1.05);
		}
		from, to {
		  transform: scale(1, 1);
		}
		25% {
		  transform: scale(0.9, 1.1);
		}
		50% {
		  transform: scale(1.1, 0.9);
		}
		75% {
		  transform: scale(0.95, 1.05);
		}
	}
	@media screen and (max-width: 2560px) {
		& img{
			height:290px;
		}
	}
	@media screen and (max-width: 1600px) {
		& img{
			height:200px;
		}
	}
	@media screen and (max-width: 768px) {
		height: 170px!important;
		&:hover{
			transform: scale(1);
		}
		& img{
			height:167px;
		}
	}
`;
export const BtnBadge = styled.div`
	display: inline-block;
    padding: 0.35em 0.65em;
    font-size: .75em;
    font-weight: 700;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
	border-radius: 50rem;
	position:absolute;
	top:5px;
	right:5px;
	z-index:1;
	&.fire {
		background: rgb(251 140 0);
		>.particle1 {
		   position: absolute;
		   background-color:rgba(255,193,7,0.5);
		   border-radius:40px;
		   border-top-right-radius:0px;
		   animation: fires1 1.2s linear infinite;
			  transform:rotate(-45deg);
		   opacity:0;
		    width:42px;
			height:42px;
			left: 0px;
			top: -15px;
			z-index: -1;
		   &:before {
			  position: absolute;
			  content: '';
			  top:60%;
			  left:40%;
			  transform:translate(-50%,-50%);
			  width:50%;
			  height:50%;
			  border-radius:40px;
			  border-top-right-radius:0px;
			  //background-color:rgba(251,140,0,0.5);
		   }
		}
		>.particle2 {
			position: absolute;
			background-color:rgba(255,193,7,0.5);
			border-radius:40px;
			border-top-right-radius:0px;
			animation: fires1 1.5s linear infinite;
			animation-delay: 0.2s;
			transform:rotate(-45deg);
			opacity:0;
			width:42px;
			height:42px;
			left: 0px;
			top: -15px;
			z-index: -1;
			&:before {
				position: absolute;
				content: '';
				top:60%;
				left:40%;
				transform:translate(-50%,-50%);
				width:50%;
				height:50%;
				border-radius:40px;
				border-top-right-radius:0px;
				//background-color:rgba(251,140,0,0.5);
			}
		}
		
	}
	&.new{
		background:red;
	}
	@keyframes fires1 {
		0% {
		   transform: rotate(-50deg) translateY(0%);
		   opacity:0.8;
		}
		25% {
		   transform: rotate(-20deg) translateY(0%);
		   opacity:1;
		}
		50%{
		   transform: rotate(-50deg) translateY(0%);
		}
		75% {
		   transform: rotate(-20deg) translateY(0%);
		   opacity:0.8;
		}
		100% {
		   transform: rotate(-50deg) translateY(0%);
		   opacity:1;
		}
	}
	
`;
export const ContentCardImage = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: end;
	align-items: center;
	width: 100%;
	height: 100%;
	border-radius: 5px;
	opacity:0;
	position:absolute;
	top:0;
	background: linear-gradient(0deg, rgba(255, 255, 255, 0) 50%, rgba(20, 23, 44, 0.494) 92%);
	// background:red;
    transition: opacity 0.5s ease-in-out 0s;
	> .btnplay{
		background-color: ${PRIMARY};
		color: ${DARKER};
		border: none;
		font-weight: 700;
		padding: 0.7rem 1.5rem;
		margin-bottom: 1rem;
		box-shadow: rgb(128, 103, 4) 0px 0px 14px;
		cursor: pointer;
		transition: transform 0.3s ease 0s;
		font-size: 16px;
		&:hover{
			transform: scale(1.1);
			transition: transform 0.3s ease 0s;
		}
		@media screen and (max-width: 768px) {
			font-size: 10px;
		}
	}
	&:hover{
		opacity:1;
	}
`;
export const ContentTitleBtn = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
  
`
export const BtnViewMore = styled(Link)`
	position: relative;
	display: inline-block;
	cursor: pointer;
	outline: none;
	border: 0;
	vertical-align: middle;
	text-decoration: none;
	background: transparent;
	padding: 0;
	font-size: inherit;
	font-family: inherit;
	width: 12rem;
  	height: auto;
	margin-left:1.5rem;
	& .circle{
		transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
		position: relative;
		display: block;
		margin: 0;
		width: 3rem;
		height: 3rem;
		background: ${PRIMARY};
		border-radius: 1.625rem;
		.icon{
			transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
			position: absolute;
			top: 0;
			bottom: 0;
			margin: auto;
			background: #fff;
		}
		.icon.arrow{
			font-weight: bold;
			transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1) 0s;
			left: 15px;
			width: 0;
			height: 30px;
			background: none;
			font-size: 27px;
			color: ${SECONDARY};
		}
	}
	.circle .icon.arrow::before {
		position: absolute;
		content: "";
		top: -0.25rem;
		right: 0.0625rem;
		width: 0.625rem;
		height: 0.625rem;
		// border-top: 0.15rem solid #fff;
		// border-right: 0.15rem solid #fff;
		transform: rotate(45deg);
	  }
	.button-text {
		transition: all 0.45s cubic-bezier(0.65, 0, 0.076, 1);
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		padding: 0.75rem 0;
		margin: 0 0 0 1.85rem;
		color: ${SECONDARY};
		font-weight: 700;
		line-height: 1.6;
		text-align: center;
		text-transform: uppercase;
	  }
	  &:hover .circle {
		width: 100%;
	  }
	  &:hover .circle .icon.arrow {
		background: #fff;
		transform: translate(1rem, 0);
	  }
	  &:hover .button-text {
		color: ${SECONDARY};
	  }
	  @media screen and (max-width: 768px) {
		width: 8rem;
		& .circle{
			width: 100%;
			height: 2.5rem
		}
		& .button-text{
			color:${SECONDARY};
			font-size: 14px;
			line-height: 1.3;
		}
		& .circle .icon.arrow{
			transform: translate(0, 0);
		}
	  }
`
export const SeoH1 = styled.h1`
	font-size: 0.9rem;
	color: #777;
	font-weight: 400;
	width: 90%;
	margin-bottom: 0.3rem;
	@media screen and (max-width: 768px) {
		font-size: 0.7rem;
		width: 100%;
		> br {
			display:none;
		}
	}
`;

export const SeoH2 = styled.h2`
	font-size: 0.9rem;
	color: #777;
	font-weight: 400;
	width: 90%;
	margin-bottom: 0.3rem;
	@media screen and (max-width: 768px) {
		font-size: 0.7rem;
		width: 100%;
		> br {
			display:none;
		}
	}
`;